import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import PageShell from '../components/PageShell';
import Tabs from '../components/Tabs';
import { resolveTabs } from '../i18n/resolveTabs';
import PlStructurePage from './PlStructurePage';
import BsStructurePage from './BsStructurePage';
import CfCategoriesPage from './financials/CfCategoriesPage';

/* Input Financials — page conteneur des saisies Financials. Sous-onglets :
     • Structure CR / Bilan → blocs + lignes de reporting (déplacé des États financiers)
     (Le mapping comptes → lignes vit dans son hub « Mapping ».)
     • Cash réel    → encaissements / décaissements réels
   (Les ajustements manuels vivent dans États financiers, dernier onglet.)
   Gabarit unique : <PageShell framed> + <Tabs> + sous-pages en mode embedded.
   Année + clôture : cluster global porté par le PageHeader (à droite du titre). */
const TAB_DEFS = [
  // « Paramètres généraux » (ligne de crédit) déplacé dans Paramètres › Finance.
  { id: 'pl-structure', labelKey: 'finance:input.tabs.pl-structure' },
  { id: 'bs-structure', labelKey: 'finance:input.tabs.bs-structure' },
  // Catégories de flux : paramétrage de structure, rapatrié de l'onglet Flux de
  // trésorerie (un rapport) le 2026-08-09.
  { id: 'cf-categories', labelKey: 'finance:input.tabs.cf-categories' },
];

export default function FinancialsInputHub({ activeTenant, setPage, addToast, year, embedded = false }) {
  const { t } = useTranslation();
  const [tab, setTab] = useState('pl-structure');
  const TABS = resolveTabs(TAB_DEFS, t);

  /* `embedded` : rendu SANS gabarit de page (2026-09-27). Dans les Paramètres
     du client, la page porte déjà son titre et le panneau le redit à gauche ;
     un troisième « Paramètres » au-dessus des onglets ne disait rien de plus. */
  const Shell = embedded
    ? ({ children }) => <>{children}</>
    : ({ children }) => <PageShell framed title={t('finance:input.title')}>{children}</PageShell>;
  return (
    <Shell>
      <Tabs
        tabs={TABS}
        active={tab}
        onChange={setTab}
      />

      <div className="page-shell__panel">
        {tab === 'pl-structure' && (
          <PlStructurePage activeTenant={activeTenant} addToast={addToast} year={year} />
        )}
        {tab === 'bs-structure' && (
          <BsStructurePage activeTenant={activeTenant} addToast={addToast} year={year} />
        )}
        {tab === 'cf-categories' && (
          <CfCategoriesPage activeTenant={activeTenant} addToast={addToast} />
        )}
      </div>
    </Shell>
  );
}
